/* eslint-disable react/no-unknown-property */
import { h } from 'preact';
import SVGWrapper from '../../SVGWrapper';

function TvInfoIcon({ height = 70, width = 70 }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 70 70"
      fill="none"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M35.0002 32.3907C34.1372 32.3907 33.4377 33.0895 33.4377 33.9514V43.33C33.4377 44.192 34.1372 44.8907 35.0002 44.8907C35.8631 44.8907 36.5627 44.192 36.5627 43.33V33.9514C36.5627 33.0895 35.8631 32.3907 35.0002 32.3907Z" fill="white" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M37.0835 27.1936C37.0835 28.3442 36.1508 29.2769 35.0002 29.2769C33.8496 29.2769 32.9168 28.3442 32.9168 27.1936C32.9168 26.043 33.8496 25.1103 35.0002 25.1103C36.1508 25.1103 37.0835 26.043 37.0835 27.1936Z" fill="white" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M35.0009 54.7916C45.9306 54.7916 54.7918 45.9314 54.7918 35C54.7918 24.0685 45.9306 15.2083 35.0009 15.2083C24.0696 15.2083 15.2085 24.0687 15.2085 35C15.2085 45.9313 24.0696 54.7916 35.0009 54.7916ZM35.0009 57.9166C47.6564 57.9166 57.9168 47.6573 57.9168 35C57.9168 22.3426 47.6564 12.0833 35.0009 12.0833C22.3439 12.0833 12.0835 22.3426 12.0835 35C12.0835 47.6573 22.3439 57.9166 35.0009 57.9166Z" fill="white" />
    </SVGWrapper>
  );
}

export default TvInfoIcon;
